import "../Tweets.css";

//react
import { useEffect, useState } from "react";

//components
import TweetGraph from "../../reusable/TweetGraph/TweetGraph";

//hooks
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";

//utils
import { getCsvData } from "../../../utils/functions/getCsvData";

//assets
import TEXT from "../../../utils/text/prensa.json";

//functionss
import { formatTrimesterLabel } from "../../../utils/functions/formatTrimesterLabel";

export default function SentimentRetorno({
  selectedCountry,
  countryName,
  countries,
  countryOptions,
  //setImg1,
  setImg2,
  setImg3,
  //setImg4,
}) {
  //language
  const { language } = useCurrentLanguage();

  //useState - data sent
  const [dataSent, setDataSent] = useState([]);

  //useState - data body
  const [dataBody, setDataBody] = useState([]);

  //useState - data xeno - body
  const [data_xeno_body, setData_xeno_body] = useState([]);

  //useState - img url 1
  //const [imgUrl1, setImgUrl1] = useState("");
  const [imgUrl2, setImgUrl2] = useState("");
  const [imgUrl3, setImgUrl3] = useState("");
  //const [imgUrl4, setImgUrl4] = useState("");

  //useEffect
  useEffect(() => {
    processDataT_Body(selectedCountry);
    processDataT2();
    console.log("COUNTRYOPTIONS: ", countryOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCountry, countries]);

  //useEffect - imgs
  useEffect(() => {
    //setImg1(imgUrl1);
    setImg2(imgUrl2);
    setImg3(imgUrl3);
    //setImg4(imgUrl4);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [/*imgUrl1,*/ imgUrl2, imgUrl3 /*, imgUrl4*/]);

  const processDataT_Body = async (selectedCountries) => {
    let df1 = await getCsvData(`/data/retorno/xenofobo_3m.csv`);
    let df_lac = await getCsvData(`/data/retorno/xenofobo_3m.csv`);
    let df_countries = await getCsvData(`/data/retorno/xenofobo_3m.csv`);

    //filter country
    if (selectedCountry !== "NAC") {
      df1 = df1.filter((row) => row.country === selectedCountry);
    }

    //filter NAC
    let tempDf1 = [];
    let tempDates = [];
    df_lac.forEach((e) => {
      if (!tempDates.includes(formatTrimesterLabel(e.date))) {
        tempDates.push(formatTrimesterLabel(e.date));
        tempDf1.push(e);
      } else {
        let index = tempDates.indexOf(formatTrimesterLabel(e.date));
        tempDf1[index].Xenofobo =
          (parseFloat(tempDf1[index].Xenofobo) + parseFloat(e.Xenofobo)) / 2 ||
          0;
      }
    });
    //console.log("tempDf1: ", tempDf1);
    df_lac = tempDf1;

    console.log("df_lac: ", df_lac);

    let dates = [];
    let values = [];
    let values3_lac = [];
    let values3_country1 = [];
    let values3_country2 = [];
    let values3_country3 = [];

    if (selectedCountry === "NAC") {
      df1 = df_lac;

      //filter countries
      let df_country1 =
        selectedCountries.length >= 2
          ? [...df_countries].filter(
              (row) => row.country === selectedCountries[1]
            ) || []
          : [];
      let df_country2 =
        selectedCountries.length >= 3
          ? [...df_countries].filter(
              (row) => row.country === selectedCountries[2]
            ) || []
          : [];
      let df_country3 =
        selectedCountries.length >= 4
          ? [...df_countries].filter(
              (row) => row.country === selectedCountries[3]
            ) || []
          : [];

      df_country1.forEach((e) => {
        values3_country1.push(parseFloat(e.Xenofobo));
      });
      df_country2.forEach((e) => {
        values3_country2.push(parseFloat(e.Xenofobo));
      });
      df_country3.forEach((e) => {
        values3_country3.push(parseFloat(e.Xenofobo));
      });
    }

    df1.forEach((e) => {
      dates.push(formatTrimesterLabel(e.date, language));
      values.push(parseFloat(e.Xenofobo));
    });

    if (selectedCountry !== "NAC") {
      df_lac.forEach((e) => {
        values3_lac.push(parseFloat(e.Xenofobo));
      });
    }

    let combinedArray2 = [];

    if (selectedCountry !== "NAC") {
      combinedArray2 = [dates, values, values3_lac];
    } else {
      combinedArray2 = [dates, values];
      //push countries if length > 0
      if (selectedCountries.length >= 2) combinedArray2.push(values3_country1);
      if (selectedCountries.length >= 3) combinedArray2.push(values3_country2);
      if (selectedCountries.length >= 4) combinedArray2.push(values3_country3);
    }

    let seriesName = [];
    let lac = language === "es" ? "NCA" : "NAC";
    if (
      selectedCountry !== "NAC" ||
      (selectedCountry.length === 0 && selectedCountries[0] !== "NAC")
    ) {
      seriesName = [countryName, lac];
    } else {
      seriesName = [lac];
      console.log("selectedCountries: ", selectedCountries);
      //if selected countries is a string convert to array
      if (typeof selectedCountries === "string") {
        selectedCountries = [selectedCountries];
      }

      if (selectedCountries.length >= 2) {
        let tempCountry1 = countryOptions.find(
          (e) => e.code === selectedCountries[1]
        );
        seriesName.push(
          language === "es"
            ? tempCountry1.country_text
            : tempCountry1.country_text_en
        );
      }
      if (selectedCountries.length >= 3) {
        let tempCountry2 = countryOptions.find(
          (e) => e.code === selectedCountries[2]
        );
        seriesName.push(
          language === "es"
            ? tempCountry2.country_text
            : tempCountry2.country_text_en
        );
      }
      if (selectedCountries.length >= 4) {
        let tempCountry3 = countryOptions.find(
          (e) => e.code === selectedCountries[3]
        );
        seriesName.push(
          language === "es"
            ? tempCountry3.country_text
            : tempCountry3.country_text_en
        );
      }
    }

    console.log("seriesName: ", seriesName);
    console.log("combinedArray2: ", combinedArray2);

    let temp2 = [
      {
        id: "q1",
        data: combinedArray2,
        rotate: false,
        graphType: "line",
        hasOptions: false,
        isPercentage: true,
        seriesName: seriesName,
        updateTotrimester: false,
        hasCountries: selectedCountry === "NAC" ? true : false,
        countryOptions: countries,
        useColors: false,
        selectedCountries: selectedCountries,
      },
    ];

    console.log("THIS: ", temp2);
    // updating: remove graph for xeno
    setData_xeno_body([]);
  };

  const processDataT2 = async () => {
    let df1 = await getCsvData(`/data/retorno/sentiment_3m.csv`);

    let tempMap = {};
    let uniqueDates = [];

    df1.forEach((e) => {
      if (selectedCountry !== "NAC" && e.country !== selectedCountry) return;

      let date = e.date;
      if (date.includes("/")) {
        const [day, month, year] = date.split("/");
        date = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      }

      const label = formatTrimesterLabel(date);

      if (!tempMap[label]) {
        uniqueDates.push(label);
        tempMap[label] = {
          pos: 0,
          neg: 0,
          neu: 0,
          posBody: 0,
          negBody: 0,
          neuBody: 0,
          count: 0,
        };
      }

      tempMap[label].pos += parseFloat(e.positive_sentiment) || 0;
      tempMap[label].neg += parseFloat(e.negative_sentiment) || 0;
      tempMap[label].neu += parseFloat(e.neutro_sentiment) || 0;

      tempMap[label].posBody += parseFloat(e.positive_body) || 0;
      tempMap[label].negBody += parseFloat(e.negative_body) || 0;
      tempMap[label].neuBody += parseFloat(e.neutro_body) || 0;

      tempMap[label].count++;
    });

    let dates = [];
    let valPos = [],
      valNeg = [],
      valNeu = [];
    let valPosBody = [],
      valNegBody = [],
      valNeuBody = [];

    uniqueDates.forEach((label) => {
      dates.push(label);
      const d = tempMap[label];
      const c = d.count;

      valNeg.push(c > 0 ? d.neg / c : 0);
      valPos.push(c > 0 ? d.pos / c : 0);
      valNeu.push(c > 0 ? d.neu / c : 0);

      valNegBody.push(c > 0 ? d.negBody / c : 0);
      valPosBody.push(c > 0 ? d.posBody / c : 0);
      valNeuBody.push(c > 0 ? d.neuBody / c : 0);
    });

    const seriesName1 =
      language === "es"
        ? ["Sentimiento negativo", "Sentimiento positivo", "Sentimiento neutro"]
        : ["Negative sentiment", "Positive sentiment", "Neutral sentiment"];

    let combinedArray1 = [valNeg, valPos, valNeu];

    let series1 = seriesName1.map((name, index) => ({
      name: name,
      data: combinedArray1[index],
      type: "bar",
      stack: "total",
      itemStyle: {
        borderRadius: index === 2 ? [4, 4, 0, 0] : [0, 0, 0, 0],
      },
    }));

    let graphConfig1 = [
      {
        id: "q_sent_bar",
        data: series1,
        labels: dates,
        rotate: false,
        graphType: "s_v_bar", // Trigger the Stacked Bar Renderer
        hasOptions: false,
        isPercentage: true,
        updateTotrimester: false,
        useColors: false,
      },
    ];

    const seriesName2 =
      language === "es"
        ? ["Cuerpo negativo", "Cuerpo positivo", "Cuerpo neutro"]
        : ["Negative body", "Positive body", "Neutral body"];

    let combinedArray2 = [valNegBody, valPosBody, valNeuBody];

    let series2 = seriesName2.map((name, index) => ({
      name: name,
      data: combinedArray2[index],
      type: "bar",
      stack: "total",
      itemStyle: {
        borderRadius: index === 2 ? [4, 4, 0, 0] : [0, 0, 0, 0],
      },
    }));

    let graphConfig2 = [
      {
        id: "q_body_bar",
        data: series2,
        labels: dates,
        rotate: false,
        graphType: "s_v_bar",
        hasOptions: false,
        isPercentage: true,
        updateTotrimester: false,
        useColors: false,
      },
    ];

    setDataSent(graphConfig1);
    setDataBody(graphConfig2);
  };

  //handle countries change

  const handleCountriesChange2 = (countries) => {
    console.log("countries: ", countries);
    processDataT_Body(countries);
  };

  return (
    <div className="surveys-page-content">
      <div className="surveys-page-graphs">
        <div className="survey-page-full-surveys">
          <div className="full-screen">
            <div className="nl-selector-container"></div>
            <div>
              {dataSent.length > 0 && (
                <TweetGraph
                  data={dataSent}
                  title={TEXT["sentiment"]["pos_neg_ret"]["title"][language]}
                  setImgUrl={setImgUrl2}
                />
              )}
              {dataBody.length > 0 && (
                <TweetGraph
                  data={dataBody}
                  title={
                    TEXT["sentiment"]["pos_neg_body_ret"]["title"][language]
                  }
                  setImgUrl={setImgUrl3}
                />
              )}
              {data_xeno_body.length > 0 && (
                <TweetGraph
                  data={data_xeno_body}
                  title={
                    TEXT["sentiment"]["xenophobia_body"]["title"][language] +
                    " " +
                    countryName
                  }
                  onCountriesChange={handleCountriesChange2}
                  setImgUrl={setImgUrl2}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  //return null;
}
